module.exports = __webpack_public_path__ + "img/logomem1.fd084d69.jpg";